module Shared.Admin.UnlockUser

open Shared
open Illy.SafeStack

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations
    
    type UnlockValidations = 
        | CannotUnlockOwnUser

    module UnlockValidations = 
        let toString = 
            function 
            | CannotUnlockOwnUser -> "Cannot unlock your own user account."
    
    let validateDTO currentUserId (userToUnlock: UserId) = 
        validate {
            return! !!(error CannotUnlockOwnUser)
                >>= conditional pass (fun _ -> userToUnlock <> currentUserId)
                |> unwrap
        }

type FailureReason = 
    | NothingToDo
    | FailedValidations of Validation.ValidationResult<Validations.UnlockValidations, Validation.NoWarning>
    